import { useCurrentUser } from "@twinkltech/curriculum-architect-domain-hooks";

import { userPermissions } from "@/utils/userPermissions/userPermissions";

import withPermission from "@/hocs/withPermissions/withPermissions";

import { MainLayout } from "./MainLayout";
import { useInitTwinklAnalyticsConfig } from "./utils/useInitTwinklAnalytics/useInitTwinklAnalyticsConfig";

export const MainLayoutContainer = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  useInitTwinklAnalyticsConfig();
  const { data: userData, isLoading } = useCurrentUser();

  const permissions = userPermissions(userData);

  return withPermission(MainLayout)({
    children,
    canViewCurricula: permissions.canViewCurricula,
    isLoading,
  });
};
